/* eslint-disable jsx-a11y/anchor-is-valid */
import PAButton, { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { memo } from "react";
import { ChatIcon } from "resources/svg-images/ChatIcon";
import { EmailIcon } from "resources/svg-images/EmailIcon";
import openLiveChat from "util/chat-widget/open-live-chat";
import styles from "./contactusfooter.module.scss";

function ContactUsFooter() {
  const { t } = useTranslation("common");
  return (
    <>
      <PAText className={`d-flex justify-content-center ${styles.top_heading}`} color="black" fontSize={FONT_SIZE[2]}>
        {t("ContactUs.Need_a_hand")}
        ?
      </PAText>
      <div className={`d-flex justify-content-center align-items-start ${styles.contact_us_icons}`}>
        <PAButton
          buttonType={BUTTON_TYPE.NORMAL}
          className={`${styles.live_chat_btn} d-flex justify-content-center flex-column align-items-center col-md-6`}
          onClick={(e) => {
            e.preventDefault();
            openLiveChat();
          }}
        >
          <ChatIcon />
          <div>
            {t("ContactUs.Live_Chat")}
            <span className={styles.chat_status} />
          </div>
        </PAButton>

        <a
          href="mailto:sales@partsavatar.ca"
          title="Reach Out to Us through Email for Assistance"
          className={`d-flex justify-content-center flex-column align-items-center col-md-6  ${styles.contact_container}`}
        >
          <EmailIcon />
          <PAText fontSize={FONT_SIZE[1]}>Email</PAText>
        </a>
      </div>
    </>
  );
}

export default memo(ContactUsFooter);
